const DROPDOWN = {
    onReady() {
        /*********************
        * Must be handled over a document event listener
        *********************/
        document.addEventListener('click', DROPDOWN.toggle); 
    },
    toggle(event) {
        let dropdown = event.target.closest('.dropdown');
        if (dropdown !== null) {
            let dropdowns = document.querySelectorAll('.dropdown.active');
            dropdowns.forEach(dropdown => {
                dropdown.classList.remove('active');
            });
            dropdown.classList.toggle('active');
        } else {
            let dropdowns = document.querySelectorAll('.dropdown.active');
            dropdowns.forEach(dropdown => {
                dropdown.classList.remove('active');
            });
        }
    }
}